import { InputNumber } from 'antd';
import { ComponentProps, forwardRef } from 'react';
import clsx from 'clsx';

import './OpInputNumber.scss';

interface OpInputNumberProps
  extends ComponentProps<typeof InputNumber<string | number>> {
  testId?: string;
}

export const OpInputNumber = forwardRef<HTMLInputElement, OpInputNumberProps>(
  ({ testId = 'op-input-number', className, ...inputNumberProps }, ref) => {
    return (
      <InputNumber
        ref={ref}
        className={clsx('op-input-number', className)}
        data-testid={testId}
        {...inputNumberProps}
      />
    );
  },
);
